require("datatables.net");
require("datatables.net-responsive");
$(document).ready(function() {
	if (
		$(".box-tickets--subscriptions").length &&
		$("#id_circuit_category").length
	) {
		$("#id_circuit_category").change(function() {
			filterSubscriptionTaxes();
		});

		function filterSubscriptionTaxes() {
			if ($("#id_circuit_category option").length == 1) {
				$("#quote-not-found").show();
			} else {
				$("#quote-not-found").hide();
			}
			$("#save-sub-fee").hide();
			$(".box-tickets--subscriptions").hide();
			var selected_category_id = $("#id_circuit_category").val();
			var c = 0;
			$(".box-tickets--subscriptions .ticket").each(function() {
				if (
					selected_category_id != "" &&
					(selected_category_id === "all" ||
						$(this).data("id_circuit_category") ==
							$("#id_circuit_category").val() ||
						!$(this).data("id_circuit_category"))
				) {
					$(this).css("display", "block");
					c++;
				} else {
					$(this).css("display", "none");
					$(this).removeClass("selected");
					$(this)
						.find("input")
						.prop("checked", "");
				}
			});
			if (!c && selected_category_id != "") {
				$(".box-tickets--subscriptions").hide();
				$("#quote-not-found .alert-box .text span").text("");
				var text =
					" " +
					text_no_quote.first +
					'<span class="bold"> ' +
					$("#id_race_route")
						.find("option:selected")
						.text() +
					"</span>" +
					text_no_quote.second +
					'<span class="bold">' +
					$("#id_circuit_category")
						.find("option:selected")
						.text() +
					"</span>";
				$("#quote-not-found .alert-box .text span").append(text);
				$("#quote-not-found").show();
			}
			if (c) {
				$(".box-tickets--subscriptions").fadeIn();
			}
		}

		var selectedRaces = [];
		var racesToSelect = 0;

		$(".box-tickets--subscriptions .ticket").click(function() {
			$(".ticket").removeClass("selected");
			$(this).addClass("selected");

			var typeSubTax = $(this).data("circuit_subscription_tax_type");

			$(this)
				.find("input")
				.prop("checked", true);

			racesToSelect = 0;

			if (typeSubTax === "all" || typeSubTax === "custom") {
				$("#race-selection-container").hide();
				return $("#save-sub-fee").fadeIn();
			}

			racesToSelect = $(this).data("circuit_subscription_tax_type");

			$("#tax-race-selection-table tbody tr button").each(function() {
				$(this).removeClass("selected btn-primary");
				$(this).addClass("btn-secondary--orange");
			});

			selectedRaces = [];
			if ($("#id_selected_races").val()) {
				console.log($("#id_selected_races").val());
				var races = $("#id_selected_races")
					.val()
					.split(",")
					.map(function(id) {
						if (id) {
							selectedRaces.push(parseInt(id, 10));
						}
					});

				$("#id_selected_races").val("");

				$("#tax-race-selection-table tbody tr").each(function() {
					console.log(
						selectedRaces.indexOf($(this).data("id_race")),
						$(this).data("id_race")
					);
					if (selectedRaces.indexOf($(this).data("id_race")) >= 0) {
						console.log($(this).find("button"));
						$(this)
							.find("button")
							.addClass("selected btn-primary");
						$(this)
							.find("button")
							.removeClass("btn-secondary--orange");
					}
				});
			}

			$("#save-sub-fee").hide();
			$("#race-selection-container").fadeIn();
		});

		filterSubscriptionTaxes();
		$(".box-tickets--subscriptions .ticket").each(function() {
			if ($(this).hasClass("selected")) {
				$(this).trigger("click");
			}
		});

		if ($(".box-tickets--subscriptions .ticket .selected").length) {
			var $this = $(".box-tickets--subscriptions .ticket .selected");
			var typeSubTax = $this.data("circuit_subscription_tax_type");
			if (typeSubTax === "all" || typeSubTax === "custom") {
				$("#race-selection-container").hide();
				return $("#save-sub-fee").fadeIn();
			}

			racesToSelect = $this.data("circuit_subscription_tax_type");

			$("#tax-race-selection-table tbody tr button").each(function() {
				$this.removeClass("selected btn-primary");
				$this.addClass("btn-secondary--orange");
			});

			$("#save-sub-fee").hide();
			selectedRaces = [];
			$("#race-selection-container").fadeIn();
		}

		$("#tax-race-selection-table button").click(function(e) {
			e.preventDefault();
			if (
				selectedRaces.length == racesToSelect &&
				!$(this).hasClass("selected")
			) {
				return;
			}

			var idRace = parseInt($(this).data("raceid"));
			if ($(this).hasClass("selected")) {
				selectedRaces = selectedRaces.filter(function(id) {
					console.log(id, idRace);
					return id !== idRace;
				});
				$(this).removeClass("selected btn-primary");
				$(this).addClass("btn-secondary--orange");
			} else {
				selectedRaces.push(idRace);
				$(this).addClass("selected btn-primary");
				$(this).removeClass("btn-secondary--orange");
			}
			console.log(selectedRaces);

			if (selectedRaces.length == racesToSelect) {
				$("#save-sub-fee").fadeIn();
			} else {
				$("#save-sub-fee").hide();
			}
		});

		$("#save-sub-fee").click(function() {
			$("#id_selected_races").val(
				selectedRaces.reduce(function(acc, id) {
					return acc + id + ",";
				}, "")
			);
		});
	
	}
});
